<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-2 mt-4">
              Reliability and Impact Targets
            </div>
          </v-layout>
          <v-layout row wrap class="mr-2">
            <v-flex xs12 sm4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.rele"
              prepend-icon="timelapse"
              :rules="ruleNumberMoreThanZero"
              hint="reliability"
              :suffix="localForm.relu"
              persistent-hint
              required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.rela"
              :rules="ruleNumberMoreThanZero"
              prepend-icon="running_with_errors"
              hint="actual"
              :suffix="localForm.relu"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.relt"
              :rules="ruleNumberMoreThanZero"
              prepend-icon="priority_high"
              hint="failures"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mr-2">
            <v-flex xs12 sm4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.impe"
              prepend-icon="error_outline"
              hint="impact"
              :suffix="localForm.impu"
              persistent-hint
              required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.impa"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="error"
              hint="actual"
              :suffix="localForm.impu"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.impt"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="dashboard"
              hint="type"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-2 mt-4">
              Startegy Execution Cost and Carbon
            </div>
          </v-layout>
          <v-layout row wrap class="mr-2">
            <v-flex xs12 sm6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.coste"
              prepend-icon="attach_money"
              :rules="ruleNumberMoreThanZero"
              hint="cost"
              :suffix="localForm.costu"
              persistent-hint
              required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.costa"
              :rules="ruleNumberMoreThanZero"
              prepend-icon="attach_money"
              hint="actual"
              persistent-hint
              :suffix="localForm.costu"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mr-2">
            <v-flex xs12 sm6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.carbe"
              prepend-icon="co2"
              hint="carbon"
              :rules="ruleNumberMoreThanZero"
              persistent-hint
              required
              :suffix="localForm.carbu"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.carba"
              :rules="ruleNumberMoreThanZero"
              prepend-icon="co2"
              hint="actual"
              persistent-hint
              :suffix="localForm.carbu"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-2 mt-4">
              Startegy Expectations and Targets
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.target"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="maintenance strategy target description"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-spacer/>
            <GetRegisterListPage :data="{tag: 'K6', tagd: 'M2.M5', tags: 'M2.M5'}"/>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import strategyOptions from "@/data/options/mixins/strategyOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";

import { mapGetters } from "vuex";
export default {
  components: {
    GetRegisterListPage
  },
  data() {
    return {
      valid: true,
      localForm: {
        rele: "", // reliability estimate
        rela: "", // reliabilty average
        relt: "", // reliability total
        relu: "", // reliability unit
        impe: "", // reliability estimate
        impa: "", // reliabilty average
        impt: "", // reliability total
        impu: "", // impact unit
        coste: "", // cost estimate
        costa: "", // cost average
        costu: "", // cost total
        carbe: "", // cost estimate
        carba: "", // cost average
        carbu: "", // cost total
        target: "" // ms target comments
      },
      orgForm: {
        rele: "", // reliability estimate
        rela: "", // reliabilty average
        relt: "", // reliability total
        impe: "", // reliability estimate
        impa: "", // reliabilty average
        impt: "", // reliability total
        coste: "", // cost estimate
        costa: "", // cost actual
        costu: "", // cost total
        carbe: "", // cost estimate
        carba: "", // cost actual
        carbu: "", // cost total
        target: "" // ms target comments
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.rele = this.getDetail.char.rele;
    this.localForm.rela = this.getDetail.char.rela;
    this.localForm.relt = this.getDetail.char.relt;
    this.localForm.relu = this.getDetail.char.relu;
    this.localForm.impe = this.getDetail.char.impe;
    this.localForm.impa = this.getDetail.char.impa;
    this.localForm.impt = this.getDetail.char.impt;
    this.localForm.impu = this.getDetail.char.impu;
    this.localForm.coste = this.getDetail.char.coste;
    this.localForm.costa = this.getDetail.char.costa;
    this.localForm.costu = this.getDetail.char.costu;
    this.localForm.carbe = this.getDetail.char.carbe;
    this.localForm.carba = this.getDetail.char.carba;
    this.localForm.carbu = this.getDetail.char.carbu;
    this.localForm.target = this.getDetail.char.target;

    this.orgForm.rele = this.getDetail.char.rele;
    this.orgForm.rela = this.getDetail.char.rela;
    this.orgForm.relt = this.getDetail.char.relt;
    this.orgForm.relu = this.getDetail.char.relu;
    this.orgForm.impe = this.getDetail.char.impe;
    this.orgForm.impa = this.getDetail.char.impa;
    this.orgForm.impt = this.getDetail.char.impt;
    this.orgForm.impu = this.getDetail.char.impu;
    this.orgForm.coste = this.getDetail.char.coste;
    this.orgForm.costa = this.getDetail.char.costa;
    this.orgForm.costu = this.getDetail.char.costu;
    this.orgForm.carbe = this.getDetail.char.carbe;
    this.orgForm.carba = this.getDetail.char.carba;
    this.orgForm.carbu = this.getDetail.char.carbu;
    this.orgForm.target = this.getDetail.char.target;
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    strategyOptions,
    techOptions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.rele !== this.orgForm.rele &&
        this.localForm.rele !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rele = this.localForm.rele;
        // basic
        char.rele = this.localForm.rele;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.relt !== this.orgForm.relt &&
        this.localForm.relt !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.relt = this.localForm.relt;
        // basic
        char.relt = this.localForm.relt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.rela !== this.orgForm.rela &&
        this.localForm.rela !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rela = this.localForm.rela;
        // basic
        char.rela = this.localForm.rela;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.impe !== this.orgForm.impe &&
        this.localForm.impe !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.impe = this.localForm.impe;
        // basic
        char.impe = this.localForm.impe;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.impt !== this.orgForm.impt &&
        this.localForm.impt !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.impt = this.localForm.impt;
        // basic
        char.impt = this.localForm.impt;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.impa !== this.orgForm.impa &&
        this.localForm.impa !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.impa = this.localForm.impa;
        // basic
        char.impa = this.localForm.impa;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.coste !== this.orgForm.coste &&
        this.localForm.coste !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.coste = this.localForm.coste;
        // basic
        char.coste = this.localForm.coste;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.costa !== this.orgForm.costa &&
        this.localForm.costa !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.costa = this.localForm.costa;
        // basic
        char.costa = this.localForm.costa;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.carbe !== this.orgForm.carbe &&
        this.localForm.carbe !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carbe = this.localForm.carbe;
        // basic
        char.carbe = this.localForm.carbe;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 10); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.carba !== this.orgForm.carba &&
        this.localForm.carba !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carba = this.localForm.carba;
        // basic
        char.carba = this.localForm.carba;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 12); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.target !== this.orgForm.target &&
        this.localForm.target !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.target = this.localForm.target;
        // basic
        char.target = this.localForm.target;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 13); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
